import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import lodash from 'lodash';
import DamHelper, { EnumDamHazardPotential } from '../../../../@types/model/dam/dam';
import { Autocomplete } from '@material-ui/lab';
import { FormHelperText, TextField } from '@material-ui/core';
import { createSelector } from 'reselect';

export interface IDamHazardPotentialDropDownOption {
    label : string;
    value : EnumDamHazardPotential | null;
}

export interface IDamHazardPotentialSelectorProps {
    value : EnumDamHazardPotential | null;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : EnumDamHazardPotential | null) => void;
    label ?: string;
}

interface IDamHazardPotentialSelectorState { }

class DamHazardPotentialSelector extends React.Component<IDamHazardPotentialSelectorProps, IDamHazardPotentialSelectorState> {
    constructor(props : IDamHazardPotentialSelectorProps) {
        super(props);

        this.state = {};
    }   

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : number | null;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? null);
    };

    private readonly getValue = (state : IDamHazardPotentialSelectorState, props : IDamHazardPotentialSelectorProps) => props.value;
    private readonly getRequired = (state : IDamHazardPotentialSelectorState, props : IDamHazardPotentialSelectorProps) => props.required;

    private readonly getHazardPotentials = () => DamHelper.HazardPotential;

    private readonly getHazardPotentialsForDropdown = createSelector([
        this.getRequired, this.getHazardPotentials,
    ], (required, hazardPotentials) => {
        const dropdownData = lodash.map(hazardPotentials, (element, index) => ({ label: element, value: lodash.parseInt(index) } as IDamHazardPotentialDropDownOption));

        if (!required) {
            dropdownData.unshift({
                label: 'NONE',
                value: null,
            });
        }
        
        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([
        this.getValue, this.getRequired, this.getHazardPotentials,
    ], (value, required, hazardPotentials) => {
        if (value != null) {
            const hazardPotential = hazardPotentials[value];

            if (hazardPotential) {
                return { label: hazardPotential, value: value } as IDamHazardPotentialDropDownOption;
            }
        }
        return null;
    });

    public render = () => {

        const { required, className, disabled, label } = this.props;

        const dropdownData = this.getHazardPotentialsForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'hazardPotential'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={ label ?? 'Wall Types' } />}  
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };

}

export default DamHazardPotentialSelector;